import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-asset', 'labelInteractiveAsset', 'Интерактивный актив');
